export default "__VITE_ASSET__jYMpl3qB__"